import { Component, ElementRef, ViewChild, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-import-step0',
  templateUrl: './import-step0.component.html',
  styleUrls: ['./import-step0.component.scss', './../../sync-data.component.scss']
})
export class ImportStep0Component implements OnChanges {
  @Input() data;
  @Input() onNext = false;
  @Input() onBackClick = false;
  @Output() isValidEmit = new EventEmitter<boolean>();
  @ViewChild('fileUpload', { static: false }) fileUploader: ElementRef;

  public isLoading = false;
  public errorMessage: string;

  constructor() {
  }

  ngOnChanges(): void {
    if (this.data) {
      this.data.syncData.OverrideTargetResources = true;
      this.load();
    }

    if (this.onNext)
      this.isValid();

    if (this.onBackClick)
      this.load();
  }

  public load() {
    this.data.syncData.EntityTables = null;
  }

  public isValid() {
    if (this.onNext) {
      let validation = true;
      if (!this.data.syncData.FilePath || this.data.syncData.FilePath.length === 0) {
        validation = false;
        this.errorMessage = 'SYNC_DATA.MUST_SELECT_THE_FILE';
      }
      if (this.data.syncData.FilePath.length > 0 && !this.data.syncData.FilePath.match(/^[^.]+.bdex$/)) {
        validation = false;
        this.errorMessage = 'GLOBAL.INVALID_FILE';
      }
      this.isValidEmit.emit(validation);
    }
  }

  public addFiles() {
    this.fileUploader.nativeElement.click();
  }

  public onFilesAdded() {
    if (this.fileUploader.nativeElement.files[0]) {
      this.errorMessage = '';
      this.data.syncData.FileToImport = this.fileUploader.nativeElement.files[0];
      this.data.syncData.FilePath = this.data.syncData.FileToImport.name;
      this.fileUploader.nativeElement.value = '';

    }
  }
}
